import Configuration from "./components/configuration";
import Schedule from "./components/schedule";
import Viewer from "./components/viewer";
import { useEffect, useState } from "react";

const ScheduleReports = ({
  setHasUnsavedChanges,
}: {
  setHasUnsavedChanges: (hasUnsavedChanges: boolean) => void;
}) => {
  const [data, setData] = useState<any>(null);
  const [build, setBuild] = useState<any>(null);
  const [step, setStep] = useState<number>(0);
  const [refresh, setRefresh] = useState<number>(0);
  useEffect(() => {
    if (step > 0 && step < 3) {
      setHasUnsavedChanges(true);
    } else {
      setHasUnsavedChanges(false);
    }
  }, [step]);
  return (
    <div className={`mt-4 flex flex-col gap-4`}>
      <div className="">
        <Viewer
          data={build}
          onSuccess={(data) => {
            if (data) {
              setData((prev: any) => ({ ...prev, config: data }));
            } else {
              setRefresh((prev) => prev + 1);
            }
          }}
          step={step}
          setStep={setStep}
        />
      </div>
      <div className="flex flex-col gap-4 lg:flex-row" key={refresh}>
        <div className="flex-1 lg:max-w-[400px]">
          <Configuration
            data={data}
            step={step}
            setStep={setStep}
            onSubmit={(data) => {
              setBuild(data);
            }}
          />
        </div>
        <div className="flex flex-1">
          <Schedule data={data} step={step} setStep={setStep} />
        </div>
      </div>
    </div>
  );
};

export default ScheduleReports;
